// Copy + palette for the two "campaign" carousel banners (Daily Arena,
// Puzzle Royale). Kept separate from config.ts so marketing copy for a live
// event can be edited/disabled here without touching the carousel logic.

export type Palette = {
  bg: string;
  accent: string;
  accentDark: string;
  title: string;
  subtitle: string;
  freeLabel: string;
  pillText: string;
  pillBorder: string;
  cdPillBg: string;
  cdPillBorder: string;
  cdPillText: string;
  cdNum: string;
  startsIn: string;
  ctaBg: string;
  ctaText: string;
  ctaShadow: string;
};

export const WINE: Palette = {
  bg: '#52182c',
  accent: '#f2bfa6',
  accentDark: '#c17a60',
  title: '#fdeee8',
  subtitle: '#ddb3a8',
  freeLabel: '#d6a094',
  pillText: '#f2bfa6',
  pillBorder: 'rgba(242,191,166,0.5)',
  cdPillBg: 'rgba(242,191,166,0.13)',
  cdPillBorder: 'rgba(242,191,166,0.55)',
  cdPillText: '#ffd3bf',
  cdNum: '#f2bfa6',
  startsIn: '#c4948a',
  ctaBg: '#f2bfa6',
  ctaText: '#3e1220',
  ctaShadow: '#c1907b',
};

export const INK_GOLD: Palette = {
  bg: '#1c1a17',
  accent: '#d3a34e',
  accentDark: '#8f6a26',
  title: '#f7f3ea',
  subtitle: '#b3a891',
  freeLabel: '#9c917c',
  pillText: '#d3a34e',
  pillBorder: 'rgba(211,163,78,0.5)',
  cdPillBg: 'rgba(211,163,78,0.12)',
  cdPillBorder: 'rgba(211,163,78,0.55)',
  cdPillText: '#e8c078',
  cdNum: '#d3a34e',
  startsIn: '#857b68',
  ctaBg: '#d3a34e',
  ctaText: '#241f16',
  ctaShadow: '#a97f34',
};

export interface CampaignCopy {
  enabled?: boolean;
  kicker: string;
  freeLabel: string;
  title: string;
  titleAccent: string;
  subtitle: string;
  detailsText: string;
  detailsUrl: string;
  ctaText: string;
  ctaSubtext: string;
  endsOn?: string;
}

// Live-event copy for tonight's arena. Toggle `enabled: false` (or just delete
// this object's contents) once the GCLxCircleChess Grand Open is over — the
// arena banner then falls back to ARENA_GENERIC below.
export const ARENA_CAMPAIGN: CampaignCopy = {
  enabled: false, // GCL Grand Open campaign over — use ARENA_GENERIC (no GCL reward)
  kicker: 'Daily arena · 8 PM',
  freeLabel: 'Free to enter',
  title: 'Finish Top 3 tonight.',
  titleAccent: 'Play the GCLxCircleChess Grand Open FREE',
  subtitle:
    'Free ₹1,500 entry to the FIDE rated Rapid Grand Open on 26 August · ₹4,00,000 prize pool',
  detailsText: 'Grand Open details',
  detailsUrl: 'https://circlechess.com/circlechess-road-to-gcl',
  ctaText: 'Play to win entry',
  ctaSubtext: 'Tonight at 8:00 PM',
  endsOn: '2026-08-26',
};

// Fallback copy for the arena banner once ARENA_CAMPAIGN.enabled is false.
export const ARENA_GENERIC: CampaignCopy = {
  kicker: 'Daily blitz arena',
  freeLabel: 'Free to enter',
  title: 'Daily Blitz Arena.',
  titleAccent: 'Play free, climb the board.',
  subtitle:
    'Unlimited blitz games against players at your level · live leaderboard',
  detailsText: '',
  detailsUrl: '',
  ctaText: 'Join now',
  ctaSubtext: '',
};

export const PUZZLE_ROYALE: CampaignCopy = {
  kicker: 'Daily Puzzle Royale',
  freeLabel: '',
  title: 'Race the clock,',
  titleAccent: 'climb the leaderboard.',
  subtitle:
    'Solve puzzles fastest against the room in the daily Puzzle Royale.',
  detailsText: '',
  detailsUrl: '',
  ctaText: 'Join the race',
  ctaSubtext: '',
};
